const MESSAGE_TYPE_EXTEND = "extend";
const MESSAGE_TYPE_LATEST = "latest";
const MESSAGE_TYPE_SELECT = "select";

export {
    MESSAGE_TYPE_EXTEND,
    MESSAGE_TYPE_LATEST,
    MESSAGE_TYPE_SELECT
};